module.exports = __webpack_public_path__ + "img/25.10f6444f.jpg";